var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBianjiMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_bianji_mian_svg__clip0_5179_55169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 2.1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v5.1l-6.4 6.4H2.1a.5.5 0 01-.5-.5v-11zm2.92 3.5a.52.52 0 100 1.04h5.36a.52.52 0 100-1.04H4.52zM4 8.52A.52.52 0 014.52 8h2.96a.52.52 0 110 1.04H4.52A.52.52 0 014 8.52zm11.844.482a.533.533 0 010 .754l-4.51 4.51a.457.457 0 01-.323.134h-.954a.457.457 0 01-.457-.457v-.954c0-.12.049-.237.134-.323l4.51-4.51a.533.533 0 01.754 0l.846.846z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_bianji_mian_svg__clip0_5179_55169"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_bianji_mian.6c212dbc.svg";
export { SvgTongyongBianjiMian as ReactComponent };